export const Logo = ({ light = false }) => (
  <div className="flex items-center gap-2.5" data-testid="app-logo">
    <div className="h-9 w-9 rounded-lg bg-[#2563EB] grid place-items-center text-white font-heading font-extrabold text-lg">P</div>
    <div className="leading-tight">
      <div className={`font-heading font-bold text-base tracking-tight ${light ? "text-white" : "text-slate-900"}`}>Pinslib</div>
      <div className={`font-mono text-[10px] uppercase tracking-[0.2em] ${light ? "text-blue-200" : "text-slate-500"}`}>Mock Tests</div>
    </div>
  </div>
);
